import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Funcionario } from './funcionario'

export type DSR = z.infer<typeof zod.DsrSchema>

export type DescontoDSRItem = {
    id: string
    data: string
    funcionarioId: number
    espelhoPontoId: number
    valor: string
    Funcionario: Funcionario
}

export type DescontoDSRFuncionario = DescontoDSRItem
export type DescontoDSREmpresas = DescontoDSRItem

export const descontoDsr = new ApiService<DescontoDSRItem>('desconto-dsr')
